<script setup lang="ts">
import AvaButton from '@/presentation/components/atoms/AvaButton.vue';
import AvaCard from '@/presentation/components/atoms/AvaCard.vue';
import AvaDialog from '@/presentation/components/molecules/AvaDialog.vue';
import { useConfirm } from '@/presentation/composables/useConfirm';

const { state, resolve } = useConfirm();
</script>

<template>
  <AvaDialog
    :model-value="state.open"
    max-width="480"
    persistent
    @update:model-value="(v: boolean) => !v && resolve(false)"
  >
    <AvaCard
      :title="state.title"
    >
      <div class="ava-card-body confirm-dialog__message">
        {{ state.message }}
      </div>
      <footer class="ava-card-actions">
        <span class="ava-spacer" />
        <AvaButton
          variant="text"
          @click="resolve(false)"
        >
          {{ state.cancelLabel }}
        </AvaButton>
        <AvaButton
          :color="state.color"
          variant="flat"
          @click="resolve(true)"
        >
          {{ state.confirmLabel }}
        </AvaButton>
      </footer>
    </AvaCard>
  </AvaDialog>
</template>

<style scoped>
.confirm-dialog__message {
  font-size: 0.95rem;
  color: rgba(var(--ava-color-on-surface), 0.85);
  white-space: pre-wrap;
}
</style>
